import React from 'react'
import { component_tool } from '@/tool'
const { WizSelect, WizComponent, WizRow, WizCol } = component_tool;

export default class QsSelect extends WizComponent {
    render() {
        const { options, preview, answer } = this.props
        let selectProps = {
            defaultValue: options.length ? options[0].content: null,
            style: { width: '100%' }
        }
        return (
            <WizRow>
                <WizCol>
                    {
                        !preview ? answer : (
                            <WizSelect {...selectProps} >
                                {options.map(val => <WizSelect.Option key={val.id} value={val.id}>{val.content}</WizSelect.Option>)}
                            </WizSelect>
                        )
                    }
                </WizCol>
            </WizRow>
        );
    }
}